export default function FloatingFooter() {
  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 flex flex-col items-center gap-2">
      <div className="relative">
        {/* Glow effect */}
        <div
          className="absolute -inset-1 bg-gradient-to-r from-[var(--bbs-jadeite-electric)]/30 to-[var(--bbs-synthwave-lavender)]/30 blur-lg opacity-75 transition-all duration-300"
          style={{ borderRadius: 'var(--bbs-radius-md)' }}
        />

        {/* Main plaque - squircle shape */}
        <div
          className="relative flex items-center gap-3 text-sm text-[var(--bbs-text-primary)] drop-shadow-sm transition-all duration-300 bg-[var(--luxury-glass-elevated)] border border-white/25 shadow-[var(--shadow-glass-strong)]"
          style={{
            padding: 'var(--bbs-spacing-md) var(--bbs-spacing-lg)',
            borderRadius: 'var(--bbs-radius-md)',
            backdropFilter: 'blur(var(--glass-depth-elevated))',
            WebkitBackdropFilter: 'blur(var(--glass-depth-elevated))'
          }}
        >
          {/* Jadeite mascot */}
          <img
            src="/jadeite-hummingbird.png"
            alt="Jadeite - a glass hummingbird"
            className="h-10 w-10 object-contain flex-shrink-0"
          />

          {/* Text */}
          <div className="flex flex-col">
            <span className="font-medium text-[var(--bbs-text-primary)]">help with Shellby</span>
            <a
              href="https://ghostwriter.systems/?view=about-jadeite"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-[var(--bbs-text-secondary)] hover:text-[var(--bbs-jadeite-electric)] transition-colors text-left"
            >
              part of Project Jadeite
            </a>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <p className="text-xs text-[var(--bbs-text-quaternary)] text-center flex items-center gap-1 justify-center">
        Shellby can make mistakes, so double-check her before sending.
        <img
          src="/jadeite-sparkling-heart.svg"
          alt="heart"
          className="w-3 h-3 inline-block"
        />
      </p>
    </div>
  )
}
